<template>
  <a
    class="col col-sm-12 col-md-6 col-lg-4 teaser--deals"
    :href="baseUrl + (lang === 'de' ? '/angebote/' : '/it/offerte/' ) + item.Id + '/'">
    <figure class="figure figure--thumbnail">
      <img
        :src="dealImage(item)"
        width="500"
        height="340"
        loading="lazy"
        class="lazyload"
        :alt="(item.TypeNameFull) ? item.TypeNameFull : ''"
      >
    </figure>

    <div class="teaser__content--deals">

      <p class="h4 teaser__title--deals font-weight-bold">{{ (item.TypeNameFull) ? item.TypeNameFull : '' }}</p>
      <p class="h4 font-color-secondary">{{ convertToCurrency(item.Price) }}</p>

      <p class="title--small">
        {{
          `${item.TransmissionTypeText ? item.TransmissionTypeText + ' | ' : ''}${item.FuelTypeText ? item.FuelTypeText + ' | ' : ''}${item.BodyTypeText} | ${item.Hp ? item.Hp + ' ' + lexicon.hp + ' | ' : ''}${item.BodyColorText} | ${item.ConditionTypeText} | ${item.Km} Km`
        }}
      </p>
    </div>
  </a>
</template>

<script>
import VMixins from "../VMixins/VMixins.vue";

export default {
  name: "VDeal.vue",
  mixins: [VMixins],
  data() {
    return {}
  },

  props: {
    item: Object,
    lexicon: Object
  },
  methods: {
    dealImage(item) {
      let url;
      try {
        url = item.Images.L[0]
      } catch (e) {
        url = '';
      }
      return url;
    }
  }
}
</script>
